var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('p',[_vm._v("Settings Page")]),_c('p',[_vm._v("This should be a protected area for user "+_vm._s(_vm.user.email))])])}
var staticRenderFns = []

export { render, staticRenderFns }